export { default } from "./PinterestIcon";
